import { n as useCookiesContext } from "./Cookies-Bn7Z7Gm8.js";
import { n as useUrlQueryParam } from "./UrlQueryParam-Ht6uGSXZ.js";
import { useCallback, useEffect, useMemo } from "react";
import arLocale from "date-fns/locale/ar-SA";
import enUsLocale from "date-fns/locale/en-US";
import esLocale from "date-fns/locale/es";
import faIrLocale from "date-fns/locale/fa-IR";
import frLocale from "date-fns/locale/fr";
import hiLocale from "date-fns/locale/hi";
import htLocale from "date-fns/locale/ht";
import huLocale from "date-fns/locale/hu";
import koLocale from "date-fns/locale/ko";
import nlLocale from "date-fns/locale/nl";
import plLocale from "date-fns/locale/pl";
import ptLocale from "date-fns/locale/pt";
import ruLocale from "date-fns/locale/ru";
import ukLocale from "date-fns/locale/uk";
import viLocale from "date-fns/locale/vi";
import zhCnLocale from "date-fns/locale/zh-CN";
import zhTwLocale from "date-fns/locale/zh-TW";
import buildFormatLongFn from "date-fns/locale/_lib/buildFormatLongFn";
import buildLocalizeFn from "date-fns/locale/_lib/buildLocalizeFn";
import buildLocalizeFn$1 from "date-fns/locale/_lib/buildLocalizeFn/index";
var formatLong$5 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE ፣d MMMM y",
			long: "d MMMM y",
			medium: "d MMM y",
			short: "dd/MM/y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} {{time}}",
			long: "{{date}} {{time}}",
			medium: "{{date}} {{time}}",
			short: "{{date}} {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/amLocale/localize.ts
var defaultMonthValues$4 = [
	"ጃንዩወሪ",
	"ፌብሩወሪ",
	"ማርች",
	"ኤፕሪል",
	"ሜይ",
	"ጁን",
	"ጁላይ",
	"ኦገስት",
	"ሴፕቴምበር",
	"ኦክቶበር",
	"ኖቬምበር",
	"ዲሴምበር"
];
var abbreviatedMonthValues$1 = [
	"ጃንዩ",
	"ፌብሩ",
	"ማርች",
	"ኤፕሪ",
	"ሜይ",
	"ጁን",
	"ጁላይ",
	"ኦገስ",
	"ሴፕቴ",
	"ኦክቶ",
	"ኖቬም",
	"ዲሴም"
];
var monthValues$5 = {
	narrow: abbreviatedMonthValues$1,
	abbreviated: abbreviatedMonthValues$1,
	wide: defaultMonthValues$4
};
var defaultDayValues$4 = [
	"እሑድ",
	"ሰኞ",
	"ማክሰኞ",
	"ረቡዕ",
	"ሐሙስ",
	"ዓርብ",
	"ቅዳሜ"
];
var abbreviatedDayValues$1 = [
	"እሑድ",
	"ሰኞ",
	"ማክሰኞ",
	"ረቡዕ",
	"ሐሙስ",
	"ዓርብ",
	"ቅዳሜ"
];
var dayValues$5 = {
	narrow: abbreviatedDayValues$1,
	short: abbreviatedDayValues$1,
	abbreviated: abbreviatedDayValues$1,
	wide: defaultDayValues$4
};
var defaultDayPeriodValues$5 = {
	am: "ጥዋት",
	pm: "ከሰዓት",
	midnight: "እኩለ ሌሊት",
	noon: "ቀትር",
	morning: "ጥዋት1",
	afternoon: "ከሰዓት በኋላ",
	evening: "ማታ",
	night: "ሌሊት"
};
var abbreviatedDayPeriodValues$1 = {
	...defaultDayPeriodValues$5,
	am: "ጥዋት",
	pm: "ከሰዓት"
};
var dayPeriodValues$5 = {
	narrow: abbreviatedDayPeriodValues$1,
	abbreviated: abbreviatedDayPeriodValues$1,
	wide: defaultDayPeriodValues$5
};
var defaultFormattingDayPeriodValues$4 = {
	am: "ጥዋት",
	pm: "ከሰዓት",
	midnight: "እኩለ ሌሊት",
	noon: "ቀትር",
	morning: "ጥዋት1",
	afternoon: "ከሰዓት በኋላ",
	evening: "ማታ",
	night: "ሌሊት"
};
var abbreviatedFormattingDayPeriodValues$1 = {
	...defaultFormattingDayPeriodValues$4,
	am: "ጥዋት",
	pm: "ከሰዓት"
};
var formattingDayPeriodValues$4 = {
	narrow: abbreviatedFormattingDayPeriodValues$1,
	abbreviated: abbreviatedFormattingDayPeriodValues$1,
	wide: defaultFormattingDayPeriodValues$4
};
var localize$5 = {
	ordinalNumber: enUsLocale.localize.ordinalNumber,
	era: enUsLocale.localize.era,
	quarter: enUsLocale.localize.quarter,
	month: buildLocalizeFn({
		values: monthValues$5,
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn({
		values: dayValues$5,
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn({
		values: dayPeriodValues$5,
		defaultWidth: "wide",
		formattingValues: formattingDayPeriodValues$4,
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/amLocale/locale.ts
/**
* @type {Locale}
* @category Locales
* @summary Amharic locale.
* @language Amharic
*/
var amLocale = {
	code: "am",
	formatDistance: enUsLocale.formatDistance,
	formatLong: formatLong$5,
	formatRelative: enUsLocale.formatRelative,
	localize: localize$5,
	match: enUsLocale.match,
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 1
	}
};
var formatLong$4 = {
	date: enUsLocale.formatLong.date,
	time: enUsLocale.formatLong.time,
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'sa' {{time}}",
			long: "{{date}} 'sa' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/filLocale/formatRelative.ts
var formatRelativeLocale$1 = {
	lastWeek: "'noong nakaraang' eeee 'ng' p",
	yesterday: "'kahapon ng' p",
	today: "'ngayong ng' p",
	tomorrow: "'bukas ng' p",
	nextWeek: "'susunod na' eeee 'ng' p",
	other: "P"
};
function formatRelative$1(token) {
	return formatRelativeLocale$1[token];
}
//#endregion
//#region src/Locale/dateFnsLocales/filLocale/localize.ts
var monthValues$4 = {
	narrow: [
		"E",
		"P",
		"M",
		"A",
		"M",
		"H",
		"H",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"Ene",
		"Peb",
		"Mar",
		"Abr",
		"May",
		"Hun",
		"Hul",
		"Ago",
		"Set",
		"Okt",
		"Nob",
		"Dis"
	],
	wide: [
		"Enero",
		"Pebrero",
		"Marso",
		"Abril",
		"Mayo",
		"Hunyo",
		"Hulyo",
		"Agosto",
		"Setyembre",
		"Oktubre",
		"Nobyembre",
		"Disyembre"
	]
};
var shortDayValues = [
	"Lin",
	"Lun",
	"Mar",
	"Miy",
	"Huw",
	"Biy",
	"Sab"
];
var dayValues$4 = {
	narrow: [
		"Li",
		"Lu",
		"Ma",
		"Mi",
		"Hu",
		"Bi",
		"Sa"
	],
	short: shortDayValues,
	abbreviated: shortDayValues,
	wide: [
		"Linggo",
		"Lunes",
		"Martes",
		"Miyerkules",
		"Huwebes",
		"Biyernes",
		"Sabado"
	]
};
var defaultFormattingDayPeriodValues$3 = {
	am: "AM",
	pm: "PM",
	midnight: "ng hatinggabi",
	noon: "ng tanghali",
	morning: "ng umaga",
	afternoon: "ng hapon",
	evening: "ng gabi",
	night: "ng gabi"
};
var formattingDayPeriodValues$3 = {
	narrow: {
		...defaultFormattingDayPeriodValues$3,
		am: "A",
		pm: "P"
	},
	abbreviated: defaultFormattingDayPeriodValues$3,
	wide: defaultFormattingDayPeriodValues$3
};
var defaultDayPeriodValues$4 = {
	am: "AM",
	pm: "PM",
	midnight: "hatinggabi",
	noon: "tanghali",
	morning: "umaga",
	afternoon: "hapon",
	evening: "gabi",
	night: "gabi"
};
var dayPeriodValues$4 = {
	narrow: {
		...defaultDayPeriodValues$4,
		am: "A",
		pm: "P"
	},
	abbreviated: defaultDayPeriodValues$4,
	wide: defaultDayPeriodValues$4
};
function ordinalNumber(dirtyNumber) {
	return `ika-${Number(dirtyNumber)}`;
}
var localize$4 = {
	ordinalNumber,
	era: enUsLocale.localize.era,
	quarter: enUsLocale.localize.quarter,
	month: buildLocalizeFn$1({
		values: monthValues$4,
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn$1({
		values: dayValues$4,
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn$1({
		values: dayPeriodValues$4,
		defaultWidth: "wide",
		formattingValues: formattingDayPeriodValues$3,
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/filLocale/locale.ts
/**
* Filipino locale adapted from date-fns v2.28.0. This locale is not supported
* in v2.29.3
* See https://github.com/date-fns/date-fns/tree/v2.28.0/src/locale/fil
* @type {Locale}
* @category Locales
* @summary Filipino locale.
* @language Filipino
* @iso-639-2 fil
* @author Ian De La Cruz [@RIanDeLaCruz]{@link https://github.com/RIanDeLaCruz}
*/
var filLocale = {
	code: "fil",
	formatDistance: enUsLocale.formatDistance,
	formatLong: formatLong$4,
	formatRelative: formatRelative$1,
	localize: localize$4,
	match: enUsLocale.match,
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
var formatLong$3 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, d 'di' MMMM 'di' yyyy",
			long: "d 'di' MMMM 'di' yyyy",
			medium: "d 'di' MMM 'di' yyyy",
			short: "d/MM/yyyy"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'na' {{time}}",
			long: "{{date}} 'na' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/keaLocale/localize.ts
var defaultMonthValues$3 = [
	"Janeru",
	"Fevereru",
	"Marsu",
	"Abril",
	"Maiu",
	"Junhu",
	"Julhu",
	"Agostu",
	"Sitenbru",
	"Otubru",
	"Novenbru",
	"Dizenbru"
];
var abbreviatedMonthValues = [
	"Jan.",
	"Fev.",
	"Marsu",
	"Abril",
	"Maiu",
	"Junhu",
	"Julhu",
	"Ago.",
	"Sit.",
	"Otu.",
	"Nov.",
	"Diz."
];
var monthValues$3 = {
	narrow: abbreviatedMonthValues,
	abbreviated: abbreviatedMonthValues,
	wide: defaultMonthValues$3
};
var defaultDayValues$3 = [
	"Dumingu",
	"Sigunda-fera",
	"Tersa-fera",
	"Kuarta-fera",
	"Kinta-fera",
	"Sesta-fera",
	"Sabadu"
];
var abbreviatedDayValues = [
	"Dum",
	"Sig",
	"Ter",
	"Kua",
	"Kin",
	"Ses",
	"Sab"
];
var dayValues$3 = {
	narrow: abbreviatedDayValues,
	short: abbreviatedDayValues,
	abbreviated: abbreviatedDayValues,
	wide: defaultDayValues$3
};
var defaultDayPeriodValues$3 = {
	am: "di sedu",
	pm: "di tardi",
	midnight: "meia noti",
	noon: "meiu dia",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
};
var abbreviatedDayPeriodValues = {
	...defaultDayPeriodValues$3,
	am: "SEDU",
	pm: "TARDI"
};
var dayPeriodValues$3 = {
	narrow: abbreviatedDayPeriodValues,
	abbreviated: abbreviatedDayPeriodValues,
	wide: defaultDayPeriodValues$3
};
var defaultFormattingDayPeriodValues$2 = {
	am: "di sedu",
	pm: "di tardi",
	midnight: "meia noti",
	noon: "meiu dia",
	morning: "in the morning",
	afternoon: "in the afternoon",
	evening: "in the evening",
	night: "at night"
};
var abbreviatedFormattingDayPeriodValues = {
	...defaultFormattingDayPeriodValues$2,
	am: "SEDU",
	pm: "TARDI"
};
var formattingDayPeriodValues$2 = {
	narrow: abbreviatedFormattingDayPeriodValues,
	abbreviated: abbreviatedFormattingDayPeriodValues,
	wide: defaultFormattingDayPeriodValues$2
};
var localize$3 = {
	ordinalNumber: enUsLocale.localize.ordinalNumber,
	era: enUsLocale.localize.era,
	quarter: enUsLocale.localize.quarter,
	month: buildLocalizeFn({
		values: monthValues$3,
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn({
		values: dayValues$3,
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn({
		values: dayPeriodValues$3,
		defaultWidth: "wide",
		formattingValues: formattingDayPeriodValues$2,
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/keaLocale/locale.ts
/**
* @type {Locale}
* @category Locales
* @summary Cape Verdean Creole locale.
* @language Cape Verdean Creole
*/
var keaLocale = {
	code: "kea",
	formatDistance: enUsLocale.formatDistance,
	formatLong: formatLong$3,
	formatRelative: enUsLocale.formatRelative,
	localize: localize$3,
	match: enUsLocale.match,
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 1
	}
};
var formatLong$2 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, d MMMM 'ឆ្នាំ' yyyy",
			long: "d MMMM 'ឆ្នាំ' yyyy",
			medium: "d MMM 'ឆ្នាំ' yyyy",
			short: "d/MM/yyyy"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'ម៉ោង' {{time}}",
			long: "{{date}} 'ម៉ោង' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/kmLocale/localize.ts
var defaultMonthValues$2 = [
	"មករា",
	"កុម្ភៈ",
	"មីនា",
	"មេសា",
	"ឧសភា",
	"មិថុនា",
	"កក្កដា",
	"សីហា",
	"កញ្",
	"តុលា",
	"វិច្ឆិកា",
	"ធ្"
];
var monthValues$2 = {
	narrow: defaultMonthValues$2,
	abbreviated: defaultMonthValues$2,
	wide: defaultMonthValues$2
};
var defaultDayValues$2 = [
	"អាទិត្យ",
	"ច័ន្",
	"អង្គារ",
	"ពុធ",
	"ព្រហស្បតិ៍",
	"សុក្",
	"សៅរ៍"
];
var dayValues$2 = {
	narrow: defaultDayValues$2,
	short: defaultDayValues$2,
	abbreviated: defaultDayValues$2,
	wide: defaultDayValues$2
};
var defaultDayPeriodValues$2 = {
	am: "ព្រឹក",
	pm: "រសៀល",
	midnight: "mi",
	noon: "n",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
};
var dayPeriodValues$2 = {
	narrow: defaultDayPeriodValues$2,
	abbreviated: defaultDayPeriodValues$2,
	wide: defaultDayPeriodValues$2
};
var defaultFormattingDayPeriodValues$1 = {
	am: "ព្រឹក",
	pm: "រសៀល",
	midnight: "mi",
	noon: "n",
	morning: "in the morning",
	afternoon: "in the afternoon",
	evening: "in the evening",
	night: "at night"
};
var formattingDayPeriodValues$1 = {
	narrow: defaultFormattingDayPeriodValues$1,
	abbreviated: defaultFormattingDayPeriodValues$1,
	wide: defaultFormattingDayPeriodValues$1
};
var localize$2 = {
	ordinalNumber: enUsLocale.localize.ordinalNumber,
	era: enUsLocale.localize.era,
	quarter: enUsLocale.localize.quarter,
	month: buildLocalizeFn({
		values: monthValues$2,
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn({
		values: dayValues$2,
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn({
		values: dayPeriodValues$2,
		defaultWidth: "wide",
		formattingValues: formattingDayPeriodValues$1,
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/kmLocale/locale.ts
/**
* @type {Locale}
* @category Locales
* @summary Khmer locale.
* @language Khmer
* @iso-639-2 khm
*/
/**
* TODO @azizkamoun: replace enUsLocale implementations with custom, local km implementations necessary for vaccine
* participant flows
*/
var kmLocale = {
	code: "km",
	formatDistance: enUsLocale.formatDistance,
	formatLong: formatLong$2,
	formatRelative: enUsLocale.formatRelative,
	localize: localize$2,
	match: enUsLocale.match,
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 1
	}
};
var formatLong$1 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, d MMMM yyyy",
			long: "d MMMM yyyy",
			medium: "d MMM yyyy",
			short: "d/MM/yyyy"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'markay saacadu tahay:' {{time}}",
			long: "{{date}} 'markay saacadu tahay:' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/soLocale/localize.ts
var defaultMonthValues$1 = [
	"Janaayo",
	"Febaraayo",
	"Maarso",
	"Abriil",
	"Maayo",
	"Juun",
	"Luuliyo",
	"Agoosto",
	"Sibteembar",
	"Oktoobar",
	"Nufeembar",
	"Diseembar"
];
var monthValues$1 = {
	narrow: defaultMonthValues$1,
	abbreviated: defaultMonthValues$1,
	wide: defaultMonthValues$1
};
var defaultDayValues$1 = [
	"Axad",
	"Isniin",
	"Talaado",
	"Arbaco",
	"Khamiis",
	"Jimce",
	"Sabti"
];
var dayValues$1 = {
	narrow: defaultDayValues$1,
	short: defaultDayValues$1,
	abbreviated: defaultDayValues$1,
	wide: defaultDayValues$1
};
var defaultDayPeriodValues$1 = {
	am: "galinka hore",
	pm: "galinka danbe",
	midnight: "saqdhexe",
	noon: "duhurkii",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
};
var dayPeriodValues$1 = {
	narrow: defaultDayPeriodValues$1,
	abbreviated: defaultDayPeriodValues$1,
	wide: defaultDayPeriodValues$1
};
var defaultFormattingDayPeriodValues = {
	am: "galinka hore",
	pm: "galinka danbe",
	midnight: "saqdhexe",
	noon: "duhurkii",
	morning: "in the morning",
	afternoon: "in the afternoon",
	evening: "in the evening",
	night: "at night"
};
var formattingDayPeriodValues = {
	narrow: defaultFormattingDayPeriodValues,
	abbreviated: defaultFormattingDayPeriodValues,
	wide: defaultFormattingDayPeriodValues
};
var localize$1 = {
	ordinalNumber: enUsLocale.localize.ordinalNumber,
	era: enUsLocale.localize.era,
	quarter: enUsLocale.localize.quarter,
	month: buildLocalizeFn({
		values: monthValues$1,
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn({
		values: dayValues$1,
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn({
		values: dayPeriodValues$1,
		defaultWidth: "wide",
		formattingValues: formattingDayPeriodValues,
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/soLocale/locale.ts
/**
* @type {Locale}
* @category Locales
* @summary Somali locale.
* @language Somali
* @iso-639-2 som
*/
var soLocale = {
	code: "som",
	formatDistance: enUsLocale.formatDistance,
	formatLong: formatLong$1,
	formatRelative: enUsLocale.formatRelative,
	localize: localize$1,
	match: enUsLocale.match,
	options: {
		weekStartsOn: 6,
		firstWeekContainsDate: 1
	}
};
var formatLong = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE، MMMM d، y",
			long: "MMMM d، y",
			medium: "MMM d، y",
			short: "d/M/yy"
		},
		defaultWidth: "full"
	}),
	time: enUsLocale.formatLong.time,
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} {{time}}",
			long: "{{date}} {{time}}",
			medium: "{{date}} {{time}}",
			short: "{{date}} {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/urLocale/formatRelative.ts
var formatRelativeLocale = {
	lastWeek: "'گزشتہ' eeee p 'بعد دوپہر'",
	yesterday: "'گزشتہ کل' p 'بعد دوپہر'",
	today: "'آج' p 'بعد دوپہر'",
	tomorrow: "'آئندہ کل' p 'بعد دوپہر'",
	nextWeek: "'اگلے' eeee p 'بعد دوپہر'",
	other: "P"
};
var formatRelative = (token) => formatRelativeLocale[token];
//#endregion
//#region src/Locale/dateFnsLocales/urLocale/localize.ts
var defaultEraValues = ["قبل مسیح", "عیسوی"];
var eraValues = {
	narrow: defaultEraValues,
	abbreviated: defaultEraValues,
	wide: defaultEraValues
};
var defaultMonthValues = [
	"جنوری",
	"فروری",
	"مارچ",
	"اپریل",
	"مئی",
	"جون",
	"جولائی",
	"اگست",
	"ستمبر",
	"اکتوبر",
	"نومبر",
	"دسمبر"
];
var monthValues = {
	narrow: [
		"J",
		"F",
		"M",
		"A",
		"M",
		"J",
		"J",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: defaultMonthValues,
	wide: defaultMonthValues
};
var defaultDayValues = [
	"اتوار",
	"پیر",
	"منگل",
	"بدھ",
	"جمعرات",
	"جمعہ",
	"ہفتہ"
];
var dayValues = {
	narrow: defaultDayValues,
	short: defaultDayValues,
	abbreviated: defaultDayValues,
	wide: defaultDayValues
};
var defaultDayPeriodValues = {
	am: "AM",
	pm: "PM",
	midnight: "آدھی رات",
	morning: "صبح",
	afternoon: "دوپہر",
	evening: "ማታ",
	night: "رات"
};
var dayPeriodValues = {
	narrow: defaultDayPeriodValues,
	abbreviated: defaultDayPeriodValues,
	wide: defaultDayPeriodValues
};
var defaultQuarterValues = [
	"پہلی سہ ماہی",
	"دوسری سہ ماہی",
	"تیسری سہ ماہی",
	"چوتهی سہ ماہی"
];
var quarterValues = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: defaultQuarterValues,
	wide: defaultQuarterValues
};
var localize = {
	ordinalNumber: enUsLocale.localize.ordinalNumber,
	era: buildLocalizeFn({
		values: eraValues,
		defaultWidth: "wide"
	}),
	quarter: buildLocalizeFn({
		values: quarterValues,
		formattingValues: quarterValues,
		defaultWidth: "wide",
		argumentCallback: (quarter) => Number(quarter) - 1
	}),
	month: buildLocalizeFn({
		values: monthValues,
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn({
		values: dayValues,
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn({
		values: dayPeriodValues,
		defaultWidth: "wide",
		formattingValues: dayPeriodValues,
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region src/Locale/dateFnsLocales/urLocale/locale.ts
/**
* @type {Locale}
* @category Locales
* @summary Urdu locale.
* @language Urdu
*/
var urLocale = {
	code: "ur",
	formatDistance: enUsLocale.formatDistance,
	formatLong,
	formatRelative,
	localize,
	match: enUsLocale.match,
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region src/Locale/constants.ts
var Locale = /* @__PURE__ */ function(Locale) {
	Locale["ENGLISH"] = "en-US";
	Locale["SPANISH"] = "es-US";
	Locale["CHINESE_SIMPLIFIED"] = "zh-CN";
	Locale["CHINESE_TRADITIONAL"] = "zh-hant";
	Locale["PORTUGUESE"] = "pt-PT";
	Locale["HAITIAN_CREOLE"] = "ht";
	Locale["KOREAN"] = "ko";
	Locale["RUSSIAN"] = "ru-RU";
	Locale["VIETNAMESE"] = "vi";
	Locale["ARABIC"] = "ar-SA";
	Locale["FILIPINO"] = "fil";
	Locale["SAMOAN"] = "sm";
	Locale["KHMER"] = "km";
	Locale["POLISH"] = "pl";
	Locale["UKRAINIAN"] = "uk";
	Locale["URDU"] = "ur";
	Locale["FRENCH"] = "fr";
	Locale["SOMALI"] = "so";
	Locale["FARSI"] = "fa";
	Locale["CAPE_VERDEAN_CREOLE"] = "kea";
	Locale["AMHARIC"] = "am";
	Locale["MARSHALLESE"] = "mh";
	Locale["HMONG"] = "hmn";
	Locale["HINDI"] = "hi";
	Locale["HUNGARIAN"] = "hu";
	Locale["DUTCH"] = "nl";
	return Locale;
}({});
var ALL_LOCALES = Object.values(Locale);
var RIGHT_TO_LEFT_LOCALES = /* @__PURE__ */ new Set();
RIGHT_TO_LEFT_LOCALES.add("ar-SA");
RIGHT_TO_LEFT_LOCALES.add("ur");
RIGHT_TO_LEFT_LOCALES.add("fa");
var DEFAULT_LOCALE = "en-US";
var ExtraLocale = /* @__PURE__ */ function(ExtraLocale) {
	ExtraLocale["AMERICAN_SIGN_LANGUAGE"] = "ase";
	return ExtraLocale;
}({});
var MOMENT_LOCALE_NAMES = {
	["en-US"]: "en",
	["es-US"]: "es",
	["zh-CN"]: "zh-cn",
	["pt-PT"]: "pt",
	["ht"]: "ht",
	["ko"]: "ko",
	["ru-RU"]: "ru",
	["vi"]: "vi",
	["ar-SA"]: "ar",
	["fil"]: "tl-ph",
	["zh-hant"]: "zh-tw",
	["km"]: "km",
	["pl"]: "pl",
	["uk"]: "uk",
	["ur"]: "ur",
	["fr"]: "fr",
	["fa"]: "fa",
	["hi"]: "hi",
	["hu"]: "hu",
	["nl"]: "nl",
	["sm"]: "en",
	["so"]: "en",
	["kea"]: "en",
	["am"]: "en",
	["mh"]: "en",
	["hmn"]: "en"
};
var DATE_FNS_LOCALES = {
	["en-US"]: enUsLocale,
	["es-US"]: esLocale,
	["zh-CN"]: zhCnLocale,
	["pt-PT"]: ptLocale,
	["ht"]: htLocale,
	["ko"]: koLocale,
	["ru-RU"]: ruLocale,
	["vi"]: viLocale,
	["ar-SA"]: arLocale,
	["zh-hant"]: zhTwLocale,
	["pl"]: plLocale,
	["uk"]: ukLocale,
	["fr"]: frLocale,
	["fa"]: faIrLocale,
	["hi"]: hiLocale,
	["hu"]: huLocale,
	["nl"]: nlLocale,
	["sm"]: enUsLocale,
	["mh"]: enUsLocale,
	["hmn"]: enUsLocale,
	["fil"]: filLocale,
	["km"]: kmLocale,
	["kea"]: keaLocale,
	["so"]: soLocale,
	["am"]: amLocale,
	["ur"]: urLocale
};
var LOCALE_DISPLAY_NAMES = {
	["en-US"]: "English",
	["es-US"]: "Español",
	["zh-CN"]: "简体中文",
	["pt-PT"]: "Português",
	["ht"]: "Kreyòl Ayisyen",
	["ko"]: "한국어",
	["ru-RU"]: "русский",
	["vi"]: "Tiếng Việt",
	["ar-SA"]: "العربية",
	["fil"]: "Filipino",
	["zh-hant"]: "繁體中文",
	["sm"]: "Gagana fa'a Samoa",
	["km"]: "ខ្មែរ",
	["pl"]: "Polski",
	["uk"]: "українська",
	["ur"]: "اُردُو",
	["fr"]: "Français",
	["fa"]: "فارسی",
	["so"]: "Soomaali",
	["kea"]: "Kriolu",
	["am"]: "አማርኛ",
	["mh"]: "kajin Majöl",
	["hi"]: "हिन्दी",
	["hmn"]: "Hmoob",
	["ase"]: "American Sign Language (ASL)",
	["hu"]: "Magyar",
	["nl"]: "Nederlands"
};
var LOCALE_ENGLISH_NAMES = {
	["en-US"]: "English",
	["es-US"]: "Spanish",
	["zh-CN"]: "Simplified Chinese",
	["pt-PT"]: "Portuguese",
	["ht"]: "Haitian Creole",
	["ko"]: "Korean",
	["ru-RU"]: "Russian",
	["vi"]: "Vietnamese",
	["ar-SA"]: "Arabic",
	["fil"]: "Filipino",
	["zh-hant"]: "Traditional Chinese",
	["sm"]: "Samoan",
	["km"]: "Khmer",
	["pl"]: "Polish",
	["uk"]: "Ukrainian",
	["ur"]: "Urdu",
	["fr"]: "French",
	["fa"]: "Farsi",
	["so"]: "Somali",
	["kea"]: "Cape Verdean Creole",
	["am"]: "Amharic",
	["mh"]: "Marshallese",
	["hmn"]: "Hmong",
	["hi"]: "Hindi",
	["hu"]: "Hungarian",
	["nl"]: "Dutch"
};
var FRONTEND_TO_DJANGO_LOCALES = {
	["en-US"]: "en",
	["es-US"]: "es",
	["zh-CN"]: "zh-hans",
	["pt-PT"]: "pt",
	["ht"]: "ht",
	["ko"]: "ko",
	["ru-RU"]: "ru",
	["vi"]: "vi",
	["ar-SA"]: "ar",
	["fil"]: "fil",
	["zh-hant"]: "zh-hant",
	["sm"]: "sm",
	["km"]: "km",
	["pl"]: "pl",
	["uk"]: "uk",
	["ur"]: "ur",
	["fr"]: "fr",
	["fa"]: "fa",
	["so"]: "so",
	["kea"]: "kea",
	["am"]: "am",
	["mh"]: "mh",
	["hmn"]: "hmn",
	["hi"]: "hi",
	["hu"]: "hu",
	["nl"]: "nl"
};
var DJANGO_TO_FRONTEND_LOCALES = Object.fromEntries(Object.entries(FRONTEND_TO_DJANGO_LOCALES).map(([frontendLocale, djangoLocale]) => [djangoLocale, frontendLocale]));
/**
* Define these values locally instead of using the browsers Intl
* object, which requires some heavy polyfills.
*/
var ColorIso639Code = /* @__PURE__ */ function(ColorIso639Code) {
	ColorIso639Code["ENGLISH"] = "en";
	ColorIso639Code["SPANISH"] = "es";
	ColorIso639Code["CHINESE_SIMPLIFIED"] = "zh_Hans";
	ColorIso639Code["CHINESE_TRADITIONAL"] = "zh_Hant";
	ColorIso639Code["PORTUGUESE"] = "pt";
	ColorIso639Code["HAITIAN_CREOLE"] = "ht";
	ColorIso639Code["KOREAN"] = "ko";
	ColorIso639Code["RUSSIAN"] = "ru";
	ColorIso639Code["VIETNAMESE"] = "vi";
	ColorIso639Code["ARABIC"] = "ar";
	ColorIso639Code["FILIPINO"] = "fil";
	ColorIso639Code["SAMOAN"] = "sm";
	ColorIso639Code["KHMER"] = "km";
	ColorIso639Code["POLISH"] = "pl";
	ColorIso639Code["UKRAINIAN"] = "uk";
	ColorIso639Code["URDU"] = "ur";
	ColorIso639Code["FRENCH"] = "fr";
	ColorIso639Code["SOMALI"] = "so";
	ColorIso639Code["FARSI"] = "fa";
	ColorIso639Code["CAPE_VERDEAN_CREOLE"] = "kea";
	ColorIso639Code["AMHARIC"] = "am";
	ColorIso639Code["MARSHALLESE"] = "mh";
	ColorIso639Code["HMONG"] = "hmn";
	ColorIso639Code["HINDI"] = "hi";
	ColorIso639Code["HUNGARIAN"] = "hu";
	ColorIso639Code["DUTCH"] = "nl";
	return ColorIso639Code;
}({});
/**
* Translation message files are named with the language code, without country code.
* This historical naming convention is based on our use of Django i18n features,
* specifically that the Django PO file names are generated based on Django settings:
* > from django.conf.global_settings import LANGUAGES
*
* FIXME: Reconcile with Locale, migrate file names in code and on Lokalise.
* Our Locales should have both language and country code and these files should reflect that.
*/
var COLOR_ISO_639_CODE_BY_LOCALE = {
	["en-US"]: "en",
	["es-US"]: "es",
	["zh-CN"]: "zh_Hans",
	["zh-hant"]: "zh_Hant",
	["pt-PT"]: "pt",
	["ht"]: "ht",
	["ko"]: "ko",
	["ru-RU"]: "ru",
	["vi"]: "vi",
	["ar-SA"]: "ar",
	["fil"]: "fil",
	["sm"]: "sm",
	["km"]: "km",
	["pl"]: "pl",
	["uk"]: "uk",
	["ur"]: "ur",
	["fr"]: "fr",
	["so"]: "so",
	["fa"]: "fa",
	["kea"]: "kea",
	["am"]: "am",
	["mh"]: "mh",
	["hmn"]: "hmn",
	["hi"]: "hi",
	["hu"]: "hu",
	["nl"]: "nl"
};
//#endregion
//#region src/Locale/usePreferredLocale.ts
var PREFERRED_LOCALE_COOKIE_NAME = "preferredLocale";
function getValidLocale(locale) {
	if (locale.startsWith("en")) return Locale.ENGLISH;
	if (locale.startsWith("es")) return Locale.SPANISH;
	if (locale.startsWith("zh-CN")) return Locale.CHINESE_SIMPLIFIED;
	if (locale.startsWith("pt")) return Locale.PORTUGUESE;
	if (locale.startsWith("ht")) return Locale.HAITIAN_CREOLE;
	if (locale.startsWith("ko")) return Locale.KOREAN;
	if (locale.startsWith("ru")) return Locale.RUSSIAN;
	if (locale.startsWith("vi")) return Locale.VIETNAMESE;
	if (locale.startsWith("ar")) return Locale.ARABIC;
	if (locale.startsWith("fil")) return Locale.FILIPINO;
	if (locale.startsWith("zh-hant")) return Locale.CHINESE_TRADITIONAL;
	if (locale.startsWith("sm")) return Locale.SAMOAN;
	if (locale.startsWith("km")) return Locale.KHMER;
	if (locale.startsWith("pl")) return Locale.POLISH;
	if (locale.startsWith("uk")) return Locale.UKRAINIAN;
	if (locale.startsWith("ur")) return Locale.URDU;
	if (locale.startsWith("kea")) return Locale.CAPE_VERDEAN_CREOLE;
	if (locale.startsWith("fa")) return Locale.FARSI;
	if (locale.startsWith("fr")) return Locale.FRENCH;
	if (locale.startsWith("so")) return Locale.SOMALI;
	if (locale.startsWith("am")) return Locale.AMHARIC;
	if (locale.startsWith("mh")) return Locale.MARSHALLESE;
	if (locale.startsWith("hmn")) return Locale.HMONG;
	if (locale.startsWith("hi")) return Locale.HINDI;
	if (locale.startsWith("hu")) return Locale.HUNGARIAN;
	if (locale.startsWith("nl")) return Locale.DUTCH;
	return null;
}
function setDocumentLangAttribute(validLocale) {
	document.documentElement.setAttribute("lang", validLocale);
}
function getCurrentLocaleFromCookies(cookies) {
	const cookieValue = cookies[PREFERRED_LOCALE_COOKIE_NAME];
	return getValidLocale(cookieValue || navigator.language) || "en-US";
}
function usePreferredLocale() {
	const { cookies, setCookie } = useCookiesContext();
	const locale = getCurrentLocaleFromCookies(cookies);
	/**
	* `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
	* See https://getcolor.atlassian.net/browse/UXTASK-1406
	*/
	useEffect(() => {
		setDocumentLangAttribute(locale);
	}, [locale]);
	return {
		locale,
		setLocale: useCallback((newLocale) => {
			setCookie(PREFERRED_LOCALE_COOKIE_NAME, newLocale, { path: "/" });
		}, [setCookie]),
		localeIsRightToLeft: useMemo(() => RIGHT_TO_LEFT_LOCALES.has(locale), [locale])
	};
}
//#endregion
//#region src/Locale/useDateFnsLocale.ts
function useDateFnsLocale() {
	const { locale } = usePreferredLocale();
	return DATE_FNS_LOCALES[locale];
}
//#endregion
//#region src/Locale/useQueryParamLocale.ts
function useQueryParamLocale() {
	const { locale, setLocale } = usePreferredLocale();
	const { queryParam, removeQueryParam } = useUrlQueryParam("locale");
	/**
	* `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
	* See https://getcolor.atlassian.net/browse/UXTASK-1406
	*/
	useEffect(() => {
		if (queryParam) {
			removeQueryParam();
			const validLocale = getValidLocale(queryParam);
			if (validLocale && locale !== validLocale) setLocale(validLocale);
		}
	}, [
		locale,
		queryParam,
		removeQueryParam,
		setLocale
	]);
}
//#endregion
//#region src/Locale/sortLocales.ts
var sortLocales = (locales) => {
	return locales.sort((locale1, locale2) => {
		const shortLocaleName1 = MOMENT_LOCALE_NAMES[locale1];
		const shortLocaleName2 = MOMENT_LOCALE_NAMES[locale2];
		return shortLocaleName1.localeCompare(shortLocaleName2);
	});
};
//#endregion
//#region src/Locale/TestUtils/setMockPreferredLocale.ts
function setMockPreferredLocale(locale = DEFAULT_LOCALE) {
	Object.defineProperty(window.document, "cookie", {
		writable: true,
		value: `${PREFERRED_LOCALE_COOKIE_NAME}=${locale}`
	});
}
//#endregion
export { RIGHT_TO_LEFT_LOCALES as S, FRONTEND_TO_DJANGO_LOCALES as _, PREFERRED_LOCALE_COOKIE_NAME as a, Locale as b, setDocumentLangAttribute as c, COLOR_ISO_639_CODE_BY_LOCALE as d, ColorIso639Code as f, ExtraLocale as g, DJANGO_TO_FRONTEND_LOCALES as h, useDateFnsLocale as i, usePreferredLocale as l, DEFAULT_LOCALE as m, sortLocales as n, getCurrentLocaleFromCookies as o, DATE_FNS_LOCALES as p, useQueryParamLocale as r, getValidLocale as s, setMockPreferredLocale as t, ALL_LOCALES as u, LOCALE_DISPLAY_NAMES as v, MOMENT_LOCALE_NAMES as x, LOCALE_ENGLISH_NAMES as y };

//# sourceMappingURL=Locale-Du9Jb0W-.js.map